import { useEffect } from "react";

import { touchPresence } from "../session";

const PRESENCE_INTERVAL_MS = 5_000;

export const usePresenceHeartbeat = (): void => {
    useEffect(() => {
        touchPresence();
        const timer = setInterval(touchPresence, PRESENCE_INTERVAL_MS);
        return () => clearInterval(timer);
    }, []);
};

export default usePresenceHeartbeat;
